import React from 'react';
import {Route, Routes, Navigate, useLocation, matchPath} from "react-router-dom";
import * as URL from "../config/UrlConstants";
import { useEffect } from "react";
import PublicRoutesConfig from "../config/PublicRoutesConfig";
import { applySeoMeta } from "../utils/seoMeta";


const PublicRoutes = () => {
	const location = useLocation();

	useEffect(() => {
		const currentRoute = PublicRoutesConfig.find((route) =>
			matchPath({ path: route.path, end: true }, location.pathname)
		);

		applySeoMeta({
			title: currentRoute?.seoTitle,
			description: currentRoute?.seoDescription,
		});
	}, [location.pathname]);

	return (
		<Routes>
			{PublicRoutesConfig.map((route) => (
				<Route key={route.path} exact path={route.path} element={route.element}/>
			))}
			{/* Route pour toutes les autres URL */}
            <Route path="*" element={<Navigate to={URL.LOGIN_VIEW_PATH} replace />} />
		</Routes>
	);
};

export default PublicRoutes;
